var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading ? _c("div", [_c("loading-spinner")], 1) : _vm._e(),
    _vm._v(" "),
    !_vm.loading
      ? _c(
          "div",
          [
            _c("b-breadcrumb", { attrs: { items: _vm.navigationItems } }),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                ref: "deleteConfiguration",
                attrs: {
                  id: "delete-configuration",
                  title: "Delete Publisher Configuration"
                },
                on: { ok: _vm.handleDeleteOK, hidden: _vm.resetModal }
              },
              [
                _c("p", [
                  _vm._v("Are you sure you want to delete : "),
                  _c("b", [_vm._v(_vm._s(_vm.configuration.name))])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "b-container",
              [
                _c(
                  "b-row",
                  { attrs: { "align-v": "center" } },
                  [
                    _c(
                      "b-col",
                      { staticClass: "pl-0", attrs: { cols: "12" } },
                      [
                        _c("h2", { staticStyle: { display: "inline" } }, [
                          _vm._v(
                            "\n            Configurations for " +
                              _vm._s(
                                _vm.clientName.text
                                  ? _vm.clientName.text
                                  : "Please select a Publisher"
                              ) +
                              "\n          "
                          )
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  { attrs: { "align-v": "center" } },
                  [
                    _c(
                      "b-col",
                      { staticClass: "form-row", attrs: { cols: "6" } },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "navigation-links",
                            attrs: {
                              disabled: "true",
                              to: {
                                name: "alternativePayments",
                                params: { clientId: _vm.clientSelectedCode }
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            View Alternative Payments\n          "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        staticClass: "form-row",
                        attrs: { cols: "6", "align-h": "end" }
                      },
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "text-right align-self-center",
                            attrs: { cols: "5" }
                          },
                          [
                            _c("label", { attrs: { for: "table-search" } }, [
                              _vm._v("Search:")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { cols: "7" } },
                          [
                            _c("b-form-input", {
                              attrs: { id: "table-search", type: "text" },
                              model: {
                                value: _vm.search,
                                callback: function($$v) {
                                  _vm.search = $$v
                                },
                                expression: "search"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c("b-table", {
                      directives: [
                        { name: "b-scrollspy", rawName: "v-b-scrollspy" }
                      ],
                      attrs: {
                        outlined: "",
                        striped: "",
                        hover: "",
                        items: _vm.items,
                        "head-variant": "light",
                        fields: _vm.computeTableFields,
                        "current-page": _vm.currentPage,
                        "show-empty": "",
                        "empty-text":
                          "No configurations created for selected publisher.",
                        "per-page": _vm.perPage,
                        filter: _vm.search,
                        "sort-by": _vm.sortBy,
                        "sort-desc": _vm.sortDesc,
                        "sort-compare": _vm.sortCompareForConfigurations
                      },
                      on: {
                        "update:sortBy": function($event) {
                          _vm.sortBy = $event
                        },
                        "update:sort-by": function($event) {
                          _vm.sortBy = $event
                        },
                        "update:sortDesc": function($event) {
                          _vm.sortDesc = $event
                        },
                        "update:sort-desc": function($event) {
                          _vm.sortDesc = $event
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "cell(name)",
                            fn: function(data) {
                              return [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "navigation-links",
                                    attrs: {
                                      to: {
                                        name: "editConfiguration",
                                        params: {
                                          id: data.item.configurationId
                                        }
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(data.item.configurationId) +
                                        "\n            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("p", [
                                  _c("small", [
                                    _c("i", [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(data.item.name) +
                                          "\n                "
                                      )
                                    ]),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(data.item.description) +
                                        "\n              "
                                    )
                                  ])
                                ])
                              ]
                            }
                          },
                          {
                            key: "cell(cards)",
                            fn: function(data) {
                              return _vm._l(data.item.cards, function(
                                card,
                                index
                              ) {
                                return _c("img", {
                                  key: index,
                                  attrs: {
                                    src:
                                      "/static/images/logos/" + card + ".png",
                                    height: "40"
                                  }
                                })
                              })
                            }
                          },
                          {
                            key: "cell(alt_payments)",
                            fn: function(data) {
                              return _vm._l(data.item.alt_payments, function(
                                payment,
                                index
                              ) {
                                return _c("img", {
                                  key: index,
                                  attrs: {
                                    src:
                                      "/static/images/logos/" +
                                      payment +
                                      ".png",
                                    height: "40"
                                  }
                                })
                              })
                            }
                          },
                          {
                            key: "cell(expiresAt)",
                            fn: function(data) {
                              return [
                                data.item.expiresAt
                                  ? _c("div", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            data.item.expiresAt.toLocaleDateString()
                                          ) +
                                          " " +
                                          _vm._s(
                                            data.item.expiresAt.toLocaleTimeString()
                                          ) +
                                          "\n            "
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            }
                          },
                          {
                            key: "cell(actions)",
                            fn: function(data) {
                              return [
                                _c(
                                  "b-link",
                                  {
                                    staticClass: "navigation-links",
                                    on: {
                                      click: function($event) {
                                        return _vm.duplicateConfiguration(
                                          data.item.configurationId,
                                          data.item.name
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Duplicate\n            "
                                    )
                                  ]
                                ),
                                _vm._v("\n            |\n            "),
                                !data.item.expiresAt
                                  ? _c(
                                      "b-link",
                                      {
                                        directives: [
                                          {
                                            name: "b-modal",
                                            rawName: "v-b-modal",
                                            value: "delete-configuration",
                                            expression: "'delete-configuration'"
                                          }
                                        ],
                                        staticClass: "navigation-links",
                                        on: {
                                          click: function($event) {
                                            return _vm.updateDeletedItem(
                                              data.item
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              Delete\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                data.item.expiresAt
                                  ? _c(
                                      "b-link",
                                      {
                                        staticClass: "navigation-links",
                                        on: {
                                          click: function($event) {
                                            return _vm.restoreConfiguration(
                                              data.item.configurationId
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              Restore\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        812698676
                      )
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showPagination,
                            expression: "showPagination"
                          }
                        ]
                      },
                      [
                        _c("b-pagination", {
                          attrs: {
                            "total-rows": _vm.totalRows,
                            "per-page": _vm.perPage,
                            align: _vm.center
                          },
                          model: {
                            value: _vm.currentPage,
                            callback: function($$v) {
                              _vm.currentPage = $$v
                            },
                            expression: "currentPage"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "button-action-ct" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "primary" },
                        on: { click: _vm.createNewConfiguration }
                      },
                      [_vm._v("\n          Create New\n        ")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }